import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {HeaderService} from '../core/services/header.service';
import {ActivatedRoute} from '@angular/router';
import {DomSanitizer, Title} from '@angular/platform-browser';
import {AuthService} from '../core/security/auth.service';
import {merge} from 'rxjs';
import {NotificationService} from '../notification/notification.service';
import {RolesEnum} from '../core/security/roles.enum';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {tap} from 'rxjs/operators';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MatDialog} from '@angular/material/dialog';
import {MatExportDialogComponent} from '../dialogs/mat-export/mat-export-dialog.component';
import {MatAlertDialogComponent} from '../dialogs/mat-alert/mat-alert-dialog.component';
import {CallRecordingModel} from '../api/models/call-recording-model';
import {MatConfirmDialogComponent} from '../dialogs/mat-confirm/mat-confirm-dialog.component';
import {ReportsService as ReportsApiService} from '../api/services/reports.service';
import moment from 'moment';
import {MatAlertHtmlDialogComponent} from '../dialogs/mat-alert-html/mat-alert-dialog.component';
import {AudioControlComponent} from '../core/visual/audio-control/audio-control.component';
import {ExportFieldModel} from '../api/models/export-field-model';
import {CallLogsFilterModel} from '../api/models/call-logs-filter-model';
import {BasicCallLogsDatasource} from './basic-call-logs.datasource';
import {BasicCallLogsService} from './basic-call-logs.service';
import {CallLogsFilterRequest} from '../api/models/call-logs-filter-request';
import {CallLog, CallLogModel} from '../api/models';
import {ReportsService} from '../reports/reports.service';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, NgClass, NgFor, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatMiniFabButton, MatIconButton, MatIconAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { PhoneNumberPipe } from '../core/pipes/phone-number.pipe';
import { DurationPipe } from '../core/pipes/duration.pipe';
import { TextInQuotesPipe } from '../core/pipes/text-in-quotes.pipe';
import { DateTimePipe } from '../core/pipes/date-time.pipe';

@Component({
    selector: 'app-basic-call-logs-grid',
    templateUrl: './basic-call-logs-grid.component.html',
    styleUrls: ['./basic-call-logs-grid.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: true,
    imports: [
        FlexModule,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatMiniFabButton,
        MatIcon,
        MatSortHeader,
        NgClass,
        NgFor,
        MatIconButton,
        MatTooltip,
        MatIconAnchor,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        AudioControlComponent,
        AsyncPipe,
        PhoneNumberPipe,
        DurationPipe,
        TextInQuotesPipe,
        DateTimePipe,
    ],
})
export class BasicCallLogsGridComponent implements OnDestroy, OnInit, OnChanges {

  constructor(public reportsService: ReportsService,
              public callLogsService: BasicCallLogsService,
              public dialog: MatDialog,
              private callLogsApiService: ReportsApiService,
              private notificationService: NotificationService,
              private sanitized: DomSanitizer,
              private route: ActivatedRoute, public headerService: HeaderService, titleService: Title, private authService: AuthService) {

    this.paramsSubscription = this.route.queryParams.subscribe(params => {
      const callRecId = params['callRecId']; // --> Name must match wanted parameter
      console.log('new url param: ' + callRecId + ';');
      if (callRecId) {
        this.recIdFilter = callRecId;
      }
    });
  }

  displayedColumns: string[] = [
    'expand',
    'start',
    'from',
    'to',
    'callType',
    'callStatus',
    'durationIvr',
    'durationRing',
    'durationTalk',
    'durationHold',
    'durationTotal',
    'recordings',
    'surveys'
  ];

  @Input() filterChangeEvent = new EventEmitter<any>();
  @Input() showAdditionalColumns = true;
  @Input() staticFilter: any;

  @ViewChild('audioPlayer') audioPlayer: AudioControlComponent;

  hasSupportAccess = false;

  additionalFilter: any = {};
  recIdFilter: string;
  exportColumns: any[] = [];
  selectedExportColumns: any[] = [];
  isLoading = false;
  searchText: string;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  dataSource: BasicCallLogsDatasource;
  callRecordRawDetails: string;

  private paramsSubscription;
  currentAudioModel: { callId: string, recId: string };
  currentAudioTitle: string;
  currentAudioSource: string;
  currentAudioDownloadSource: string;

  ngOnInit() {
    this.hasSupportAccess = this.authService.hasAccess([RolesEnum.Support]);

    if (!this.reportsService.userRights.surveysView) {
      this.displayedColumns = this.displayedColumns.filter(x => x !== 'surveys');
    }
    if (!this.reportsService.userRights.recordingsEnabled) {
      this.displayedColumns = this.displayedColumns.filter(x => x !== 'recordings');
    }

    this.dataSource = new BasicCallLogsDatasource(this.callLogsApiService);

    this.initEvents();

    if (this.staticFilter) {
      this.filterChangeEvent.emit(this.staticFilter);
    }
  }

  initEvents() {
    this.filterChangeEvent.subscribe((filter) => {
      this.additionalFilter = filter;
      this.paginator.pageIndex = 0;
    });

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    merge(this.sort.sortChange, this.paginator.page, this.filterChangeEvent)
      .pipe(
        tap(() => this.loadCallLogs())
      )
      .subscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('ngOnChanges');

    if (changes['filterChangeEvent'] && !changes['filterChangeEvent'].firstChange) {
      this.initEvents();
    }
  }

  getDataFilter(): CallLogsFilterRequest {
    return {
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [{field: this.sort.active, direction: this.sort.direction ? this.sort.direction.toUpperCase() : undefined}],
      domain: this.reportsService.selectedDomain,
      searchText: this.searchText,
      startDate: this.additionalFilter.startDate,
      endDate: this.additionalFilter.endDate,
      // additional filter
      numberTo: this.additionalFilter.numberTo,
      numberFrom: this.additionalFilter.numberFrom,
      durationTo: this.additionalFilter.durationTo * 1000,
      durationFrom: this.additionalFilter.durationFrom * 1000,
      types: this.additionalFilter.types,
      exclude: this.additionalFilter.exclude,
      statuses: this.additionalFilter.statuses,
      extensions: this.additionalFilter.extensions,
      groupAccounts: this.additionalFilter.groupAccounts,
      callRecId: this.recIdFilter,
    };
  }

  loadCallLogs() {
    console.log('filter changed');
    this.dataSource.queryCallLogs(this.getDataFilter());
  }

  async onExportClick() {
    console.log('exportLogs');
    this.exportColumns = this.callLogsService.getExportColumns(this.showAdditionalColumns).map((x: any) => {
      return {
        text: x.title,
        value: x.id,
        field: x.field,
        hidden: x.hidden,
        id: x.id
      };
    });

    this.selectedExportColumns = this.exportColumns.filter((item) => {
      return !item.hidden;
    }).map((item) => item.id);

    const dialogRef = this.dialog.open(MatExportDialogComponent, {
      width: '500px',
      height: '60%',
      data: {
        availableColumns: this.exportColumns,
        selectedColumns: this.selectedExportColumns
      }
    });

    dialogRef.afterClosed().subscribe(async (result: any[]) => {
      if (result) {
        this.selectedExportColumns = result;
        await this.onExport();
      }
    });
  }

  async onExport() {
    const exColumns: ExportFieldModel[] = this.callLogsService
      .getExportColumns(this.showAdditionalColumns)
      .filter((x) => {
        return this.selectedExportColumns.indexOf(x.id) > -1;
      });

    const filter: CallLogsFilterModel = Object.assign({
      domain: this.reportsService.selectedDomain,
    }, this.additionalFilter || {});

    await this.callLogsService.exportLogs({
      filter: filter,
      exportFields: exColumns
    });

    this.dialog.open(MatAlertDialogComponent, {
      width: '500px',
      data: {
        title: 'Export Information',
        actionTitle: 'Got It',
        text: `Export started successfully. Process can take up to 30 minutes. When export file will be ready you will get email notification.`
      }
    });
  }

  async getCallDetails(id: string) {
    const details = await this.callLogsService.getCallDetails(id);
    console.log(details);

    this.callRecordRawDetails = JSON.stringify(details, null, '\t');

    this.dialog.open(MatAlertHtmlDialogComponent, {
      width: '90%',
      height: '90%',
      data: {
        title: 'Call Raw Details',
        actionTitle: 'Close',
        html: this.callRecordRawDetails,
        code: true
      }
    });
  }

  getStreamUrl(cdr: CallLog, recording: CallRecordingModel): string {
    const time = moment(recording.time).format('YYYY-MM-DD_h:mm:ss_a');
    return `/api/recordings/stream-recording/${this.reportsService.selectedDomain}/${recording.id}/${cdr._id}?fileName=recording_${recording.extension}_${time}.wav`;
  }

  getDownloadUrl(cdr: CallLog, recording: CallRecordingModel): string {
    const time = moment(recording.time).format('YYYY-MM-DD_h:mm:ss_a');
    return `/api/recordings/download-recording/${this.reportsService.selectedDomain}/${recording.id}/${cdr._id}?fileName=recording_${recording.extension}_${time}.wav`;
  }

  async onDeleteRecordingConfirm(recording: { callId: string, recId: string, domain: string, cdrDate: string }) {
    const dialogRef = this.dialog.open(MatConfirmDialogComponent, {
      // width: '250px',
      data: {
        title: 'Delete Recording',
        text: 'Are you sure you want to delete the selected recording?',
        actionTitle: 'Delete',
      }
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.callLogsService.deleteRecording(recording.callId, recording.recId, recording.domain, recording.cdrDate);
        this.loadCallLogs();
        await this.notificationService.notifySuccess('Recording deleted successfully');
      }
    });
  }

  onAudioError(event: any) {
    console.log(event);
    this.notificationService.notifyDanger('Recording file isn\'t available');
  }

  ngOnDestroy() {
  }

  async playRecording(cdr: CallLog, recording: CallRecordingModel) {
    this.currentAudioSource = this.getStreamUrl(cdr, recording);
    this.currentAudioDownloadSource = this.getDownloadUrl(cdr, recording);
    this.currentAudioTitle = `${recording.extension} ${recording.extensionName}`;
    this.currentAudioModel = {
      callId: cdr._id,
      recId: recording.recId
    };
  }

  isRecordingOnlySupport(cdr: CallLogModel): boolean {
    let timeFromToday = moment().diff(moment(cdr.start), 'days');
    if (this.reportsService.userRights.recordingsDaysLimit && timeFromToday > this.reportsService.userRights.recordingsDaysLimit) {
      return true;
    }
    return false;
  }
}
